import React from "react";
import PropTypes from "prop-types";

const TextInput = ({
  name,
  id,
  label,
  value,
  handleChange,
  placeholder,
  required,
  disabled,
  errorMessage,
  type,
  handleBlur,
  maxLength = 50,
  onKeyDown,
}) => {
  return (
    <div>
      <label
        className="form-label  w-100 fs-5 inmate-label"
        // style={{ color: "#2c2f32", fontWeight: "400" }}
      >
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div>
        <input
          type={type}
          className={`form-control  fs-5 ${errorMessage ? "border-danger" : ""} fw-normal`}
          placeholder={placeholder}
          name={name}
          id={id}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          required={false}
          disabled={disabled}
          maxLength={maxLength}
          onKeyDown={onKeyDown}
          // onCopy={(e) => e.preventDefault()}
          // onCut={(e) => e.preventDefault()}
          // onPaste={(e) => e.preventDefault()}
        />
        {errorMessage && (
         <div className="text-danger fw-700 fs-6 mt-1">
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
};

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string, // Updated to accept a string for error messages
  type: PropTypes.string.isRequired,
  handleBlur: PropTypes.func,
};

TextInput.defaultProps = {
  placeholder: "",
  required: false,
  disabled: false,
  id: "",
  errorMessage: "",
};

export default TextInput;
